var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.66 4.96a5.92 5.92 0 01-1.005.875C15.978 6.97 14.29 8.115 12.653 9.3c-.844.623-1.888 1.386-2.983 1.386h-.02c-1.095 0-2.14-.763-2.984-1.386C5.03 8.105 3.342 6.97 1.674 5.835A5.617 5.617 0 01.66 4.96v7.975c0 .884.723 1.607 1.607 1.607h14.785c.884 0 1.608-.723 1.608-1.607V4.961zm0-2.952c0-.884-.734-1.608-1.608-1.608H2.267C1.192.4.66 1.244.66 2.23c0 .914 1.014 2.049 1.727 2.53 1.557 1.086 3.134 2.17 4.691 3.265C7.731 8.476 8.836 9.4 9.65 9.4h.02c.813 0 1.918-.924 2.571-1.376 1.557-1.095 3.134-2.18 4.701-3.264.884-.613 1.718-1.627 1.718-2.752z",
    fill: "#9BAEF1"
  })));
}
export default __webpack_public_path__ + "media/contactForm/emailIcon-a6966936.svg";
export { SvgEmailIcon as ReactComponent };